import ApiModel from './ApiModel'

// All nullable API dates and string are declared as optional or null.
// We cannot really solve this without including the abstraction in code.
// NOTE: We generally try to use no `null` keywords to avoid mixing up empty values.
type NullableString = string | undefined | null

export interface CommonLifeCycleData {
    createdBy?: NullableString
    createdAt?: NullableString

    updatedBy?: NullableString
    lastUpdatedAt?: NullableString
    lastUsedAt?: NullableString
    lastUsedBy?: NullableString

    archivedBy?: NullableString
    archivedAt?: NullableString

    isArchived?: boolean
}

export const nullableDate = (date: NullableString) => (date ? new Date(date) : undefined)

export default class ApiLifeCycleModel<T extends CommonLifeCycleData> extends ApiModel<T> {
    get createdBy() {
        return this.data.createdBy ?? undefined
    }

    get createdAt() {
        return nullableDate(this.data.createdAt)
    }

    get updatedBy() {
        return this.data.updatedBy ?? undefined
    }

    get lastUpdatedAt() {
        return nullableDate(this.data.lastUpdatedAt)
    }

    get lastUsedAt() {
        return nullableDate(this.data.lastUsedAt)
    }

    get lastUsedBy() {
        return this.data.lastUsedBy ?? undefined
    }

    get archivedBy() {
        return this.data.archivedBy ?? undefined
    }

    get archivedAt() {
        return nullableDate(this.data.archivedAt)
    }

    get isArchived() {
        return this.data.isArchived ?? !!this.archivedAt
    }
}
